import SectionTitle from "../Common/sectionTitle.component";
import SingleFeature from "../Features/singleFeature.Features";
import benifitsData from "./benifitsData";

const Benifits = () => {
  return (
    <>
      <section
        id="features"
        className="bg-primary/[.02] py-16 md:py-20 lg:py-28"
      >
        <div className="container">
          <SectionTitle
            title="Innovative Applications"
            center
          />

          <div className="grid grid-cols-1 gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
            {benifitsData.map((benifit) => (
              <SingleFeature key={benifit.id} feature={benifit} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Benifits;
